import React from 'react';
import createReactClass from 'create-react-class';
import ModalContentBase from './modal_content_base';

export default createReactClass({
  displayName: 'Root',
  getInitialState() {
    return {
      enquete: {},
      enquetesItems: [],
      isChecked: false,
      checkedValue: null,
      maxPostCount: 0,
    };
  },
  loadEnqueteFromServer() {
    $.ajax({
      url: '/api/enquete/fetch',
      type: 'GET',
      cache: false,
      data: {
        enquete_id: this.props.enqueteId,
      },
    })
      .done(
        function (data) {
          const currentUserId = this.props.currentUserId;
          const checkedValue = data.enquetesItems
            .filter(function (item) {
              if (
                item.enquetes_items_users
                  .map(function (user) {
                    return user.user_id;
                  })
                  .includes(currentUserId)
              ) {
                return true;
              } else {
                return false;
              }
            })
            .map(function (item) {
              return item.id;
            });

          let maxPostCount = 0;
          data.enquetesItems.forEach(function (item) {
            maxPostCount =
              maxPostCount < item.enquetes_items_users.length
                ? item.enquetes_items_users.length
                : maxPostCount;
          });
          this.setState({
            enquete: data.enquete,
            enquetesItems: data.enquetesItems,
            checkedValue: checkedValue,
            maxPostCount: maxPostCount,
          });
        }.bind(this)
      )
      .fail(function () {}.bind(this));
  },
  postEnqueteToServer() {
    $.ajax({
      url: '/api/enquete/post',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        enquete_id: this.props.enqueteId,
        enquetes_item_id: this.state.enquetesItemId,
        is_checked: this.state.isChecked,
        option_type: this.state.enquete.option_type,
      },
    })
      .done(
        function () {
          this.loadEnqueteFromServer();
        }.bind(this)
      )
      .fail(function () {}.bind(this));
  },
  handleOnChange(e) {
    this.setState(
      {
        enquetesItemId: e.target.value,
        isChecked: e.target.checked,
      },
      function () {
        this.postEnqueteToServer();
      }
    );
  },
  componentDidMount() {
    this.loadEnqueteFromServer();
  },
  render() {
    const handleOnChange = this.handleOnChange;
    const checkedValue = this.state.checkedValue;
    const maxPostCount = this.state.maxPostCount;
    let barWidth = 0;
    let userNames = '';
    var option_type;
    var check_button;
    switch (this.state.enquete.option_type) {
      case 1:
        option_type = 'radio';
        check_button = <i className="fas fa-check-circle color-lightgray" />;
        break;
      case 2:
        option_type = 'checkbox';
        check_button = <i className="fas fa-check-square color-lightgray" />;
        break;
    }
    const enquetesItems = this.state.enquetesItems.map(function (item) {
      if (maxPostCount === 0) {
        barWidth = 0;
      } else {
        barWidth = (item.enquetes_items_users.length / maxPostCount) * 100;
      }

      userNames = item.enquetes_items_users.map(function (user, i) {
        if (user.user === undefined || user.user === null) {
          return (
            <p
              style={{
                wordWrap: 'normal',
                flexShrink: '0',
                fontSize: '10px',
                lineHeight: '1.4',
              }}
              key={user.id}
            >
              退会ユーザー{item.enquetes_items_users.length > i + 1 ? ',' : ''}
              &nbsp;&nbsp;
            </p>
          );
        }
        return (
          <p
            style={{
              wordWrap: 'normal',
              flexShrink: '0',
              fontSize: '10px',
              lineHeight: '1.4',
            }}
            key={user.id}
          >
            {user.user.familyname}
            {user.user.firstname}
            {item.enquetes_items_users.length > i + 1 ? ',' : ''}&nbsp;&nbsp;
          </p>
        );
      });

      return (
        <div className="mt10" key={item.id}>
          <input
            className="dsp-non"
            name="a"
            type={option_type}
            value={item.id}
            id={`enquete${item.id}`}
            onChange={handleOnChange}
            checked={checkedValue.includes(item.id)}
          />
          <label htmlFor={`enquete${item.id}`}>
            {check_button}&nbsp;{item.item}
          </label>
          <div className="response-rate flex">
            <div className="meter" style={{ width: barWidth + '%' }} />
            <p style={{ lineHeight: '1.0' }}>
              &nbsp;{item.enquetes_items_users.length}
            </p>
          </div>
          <div className="color-gray-strong flex" style={{ flexWrap: 'wrap' }}>
            {userNames}
          </div>
        </div>
      );
    });

    const previewContent = (
      <div
        style={{ maxHeight: '250px', overflow: 'hidden', borderRadius: '5px' }}
      >
        <div className="modal-view-header" style={{ background: '#ccc' }}>
          <p style={{ margin: '0', padding: '1.5em', textAlign: 'left' }}>
            <strong>{this.state.enquete.title}</strong>
          </p>
        </div>
        <div
          className="modal-view-body"
          style={{
            padding: '10px 25px 50px',
            textAlign: 'left',
            background: '#fff',
          }}
        >
          <p>{this.state.enquete.description}</p>
          <div className="mt20">
            <form className="enquete-form">{enquetesItems}</form>
          </div>
        </div>
      </div>
    );

    const modalContent = (
      <div>
        <div className="modal-view-header">
          <p style={{ margin: '0 0 6px', padding: '1.5em', textAlign: 'left' }}>
            <strong>{this.state.enquete.title}</strong>
          </p>
        </div>
        <div
          className="modal-view-body"
          style={{ padding: '0px 25px 50px', textAlign: 'left' }}
        >
          <p>{this.state.enquete.description}</p>
          <div className="mt20">
            <form className="enquete-form">{enquetesItems}</form>
          </div>
        </div>
      </div>
    );

    return (
      <ModalContentBase
        previewContent={previewContent}
        modalContent={modalContent}
      />
    );
  },
});
